import { Link } from 'react-router-dom';
import { blogPosts } from '@/lib/data/blog';

interface RelatedPostsProps {
    currentSlug: string;
}

const RelatedPosts = ({ currentSlug }: RelatedPostsProps) => {
    const related = blogPosts.filter((p) => p.slug !== currentSlug).slice(0, 3);

    if (related.length === 0) return null;

    return (
        <section className="mt-12 pt-10 border-t border-gray-200">
            <h2 className="text-sm font-bold tracking-wide text-gray-500 uppercase mb-5">
                Keep reading
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-5">
                {related.map((post) => (
                    <Link
                        key={post.slug}
                        to={`/blog/${post.slug}`}
                        className="group block rounded-xl p-4 ring-1 ring-black/5 hover:ring-black/10 hover:shadow-sm transition-all"
                    >
                        <p className="text-xs font-semibold text-gray-500 mb-1.5">
                            {post.displayDate} · {post.readingTime}
                        </p>
                        <h3 className="text-sm font-bold text-primary leading-snug group-hover:underline">
                            {post.title}
                        </h3>
                    </Link>
                ))}
            </div>
        </section>
    );
};

export default RelatedPosts;
